export { default } from './DirectionPadAlternate'
